import COLORS from 'constants/colors';
import {
  formatNumberK
} from 'util/formatters/numberFormatter';
import { findIndex, isNull, isUndefined } from 'lodash';
import { applicationTypes, scriptTypes } from 'constants/scripts';
import { getScriptTypeForScript } from 'scripts/selectors';
import { getFertilizerRateLegendForScript } from 'util/formatters/data-viz/fertilizer';
import { getSeedRateLegendForScript } from 'util/formatters/data-viz/seed';

export const getProductRateDisplayValuesFromBins = ({ applicationType, bins }) => {
  return bins.map((bin, index) => {
    let [lowerBound, upperBound] = bin;
    lowerBound = applicationType === applicationTypes.SEED ? formatNumberK(lowerBound) : lowerBound;
    upperBound = applicationType === applicationTypes.SEED ? formatNumberK(upperBound) : upperBound;

    if (index === 0) {
      return `<${upperBound}`;
    } else if (index === (bins.length - 1)) {
      return `>${lowerBound}`;
    } else {
      return lowerBound;
    }
  });
};

export const getProductRateLegendForScript = ({ state, script, productValidationValues }) => {
  if (!script) {
    return {};
  }

  const scriptType = getScriptTypeForScript(script);
  // TODO: PRDEN-58 make application specific behavior
  switch (scriptType) {
    case scriptTypes.FERTILITY:
    case scriptTypes.APPLICATION:
      return getFertilizerRateLegendForScript({ state, script, productValidationValues });
    case scriptTypes.PLANTING:
      return getSeedRateLegendForScript({ state, script, productValidationValues });
    default:
      return null; // Unexpected, causes visible error.
  }
};

export const getProductRateColorFromBins = ({ bins, colors, rate }) => {
  if (!isNull(rate) && !isUndefined(rate)) {
    let index = findIndex(bins, (bin) => {
      const [lowerBound, upperBound] = bin;
      return Math.ceil(rate) >= lowerBound && Math.ceil(rate) <= upperBound;
    });
    // index will be -1 if couldn't find
    if (index < 0) {
      const [minLowerBound] = bins[0];
      const [,maxUpperBound] = bins.slice(-1)[0];
      if (rate <= minLowerBound) {
        index = 0;
      }
      if (rate >= maxUpperBound) {
        index = bins.length - 1;
      }
    }
    return colors[index];
  }
  return COLORS.null;
};
